import moment from "moment";
import { DatePicker as MUIDatePicker } from "@mui/x-date-pickers/DatePicker";
import InfoItem from "../InfoItem";
import ReportSetting from "../ReportSetting";

export default class ReportSettingDate extends ReportSetting {
  handleDateChange = (key, value) => {
    if (value) {
      if (key === "date") {
        this.handleSettingChange(
          key,
          moment(value)
            .set({ hour: 23, minute: 59, second: 59, millisecond: 0 })
            .utc()
            .format("YYYY-MM-DDTHH:mm:ss.SSS[Z]"),
        );
      } else {
        this.handleSettingChange(
          key,
          moment(value)
            .startOf("day")
            .utc()
            .format("YYYY-MM-DDTHH:mm:ss.SSS[Z]"),
        );
      }
    } else {
      this.handleSettingChange(key, null);
    }
  };

  /**
   * Renders a date selector.
   */
  renderDatePicker() {
    const views = this.props.dateViews || ["year", "month", "day"];
    return (
      <MUIDatePicker
        label={"Date"}
        value={
          this.state.settings.date ? moment(this.state.settings.date) : null
        }
        slotProps={{
          field: {
            clearable: true,
          },
          textField: {
            size: "small",
            variant: "standard",
            required: true,
            error:
              this.props.showValidationIssues &&
              !!this.props.validationIssues?.date,
            helperText:
              this.props.showValidationIssues &&
              this.props.validationIssues?.date
                ? this.props.validationIssues?.date
                : "",
            InputLabelProps: {
              shrink: true,
            },
          },
        }}
        onChange={(date) => this.handleDateChange("date", date)}
        sx={{ width: "300px" }}
        views={views}
      />
    );
  }

  renderContent() {
    return <>{this.renderDatePicker()}</>;
  }

  renderReadOnly() {
    if (!this.state.settings.date) {
      return <InfoItem label="Date" value="None" />;
    }

    // Determine date format based on dateViews prop
    let dateFormat = "MMM D, YYYY"; // default: full date

    if (this.props.dateViews) {
      if (
        this.props.dateViews.length === 1 &&
        this.props.dateViews[0] === "year"
      ) {
        dateFormat = "YYYY"; // year only
      } else if (
        this.props.dateViews.length === 2 &&
        this.props.dateViews.includes("year") &&
        this.props.dateViews.includes("month")
      ) {
        dateFormat = "MMM YYYY"; // month and year
      }
      // Otherwise use default full date format
    }

    return (
      <InfoItem
        label="Date"
        value={moment(this.state.settings.date).format(dateFormat)}
      />
    );
  }
}
